<template>

  <modalo
    :title="customFieldGroup.name"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => customFieldGroup">

    <form
      id="customField-group-form"
      v-on:submit.prevent="saveCustomFieldGroup(customFieldGroup)">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input
          v-autofocus
          type="text"
          class="form-control"
          v-model="customFieldGroup.name">
        <ValidateMessage :error="validateErrors.name" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="customField-group-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <button
          v-if="customFieldGroup._id"
          type="button"
          :disabled="hasFields"
          class="btn btn-danger"
          @click="deleteCustomFieldGroup(customFieldGroup._id)">{{ $t('Delete') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'CustomFieldGroupModal',
  components: {
  },
  props: [
    'initCustomFieldGroup'
  ],
  data () {
    return {
      loading: false,
      customFieldGroup: this.$clone(this.initCustomFieldGroup),
      validateErrors: {}
    }
  },
  computed: {
    hasFields () {
      return this.customFieldGroup.custom_fields && this.customFieldGroup.custom_fields.length >= 1
    }
  },
  created () {
  },
  methods: {
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveCustomFieldGroup
    */
    saveCustomFieldGroup (data) {
      if (data._id) this.updateCustomFieldGroup(data._id, data)
      else this.createCustomFieldGroup(data)
    },
    /*
    createCustomFieldGroup
    */
    createCustomFieldGroup (data) {
      this.loading = true

      this.$store
      .dispatch('createCustomFieldGroup', data)
      .then((result) => {
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateCustomFieldGroup
    */
    updateCustomFieldGroup (id, data) {
      this.loading = true

      this.$store
      .dispatch('updateCustomFieldGroup', {
        ...data,
        _id: id
      })
      .then((result) => {
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteCustomFieldGroup (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteCustomFieldGroup', id)
        .then((result) => {
          this.$emit('deleted')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CustomFields/CustomFieldGroupForm.vue